import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { PriceDisplay } from './PriceDisplay';
import { Lock, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="descargar" className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-112">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-full max-h-[500px] bg-brand-red/10 blur-[100px] rounded-full pointer-events-none" data-id="element-113"></div>

      <div className="container mx-auto max-w-md relative z-10" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-black border-2 border-brand-red rounded-xl p-8 shadow-[0_0_50px_rgba(220,38,38,0.2)]" data-id="element-115">
          <div className="text-center mb-8" data-id="element-116">
            <h2 className="text-3xl font-heading font-bold text-white mb-2" data-id="element-117">
              OFERTA ESPECIAL
            </h2>
            <p className="text-gray-400 text-sm" data-id="element-118">
              Acceso Inmediato • Descarga Digital
            </p>
          </div>

          <div className="space-y-4 mb-8 border-b border-white/10 pb-8" data-id="element-119">
            <div className="flex justify-between text-gray-300" data-id="element-120">
              <span data-id="element-121">Manual Principal</span>
              <span className="line-through text-gray-500" data-id="element-122">$97</span>
            </div>
            <div className="flex justify-between text-gray-300" data-id="element-123">
              <span data-id="element-124">Biblioteca de Respuestas</span>
              <span className="line-through text-gray-500" data-id="element-125">$47</span>
            </div>
            <div className="flex justify-between text-gray-300" data-id="element-126">
              <span data-id="element-127">Plantillas + Checklist</span>
              <span className="line-through text-gray-500" data-id="element-128">$27</span>
            </div>
            <div className="flex justify-between text-brand-gold font-medium" data-id="element-129">
              <span data-id="element-130">Bonos Exclusivos</span>
              <span className="line-through text-brand-gold/50" data-id="element-131">$71</span>
            </div>
            <div className="flex justify-between pt-4 text-lg font-bold text-white" data-id="element-132">
              <span data-id="element-133">Valor Total</span>
              <span className="line-through text-gray-500" data-id="element-134">$242</span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-135">
            <p className="text-gray-400 mb-2" data-id="element-136">Hoy lo obtenés por:</p>
            <div className="flex items-center justify-center space-x-3" data-id="element-137">
              <span className="text-5xl font-bold text-white tracking-tight" data-id="element-138">
                <PriceDisplay amount={23.9} data-id="element-139" />
              </span>
            </div>
          </div>

          <Button href="https://guiaspracticas.store/cart/51259935031586:1?checkout" fullWidth className="mb-6 text-xl py-6 animate-pulse-slow" data-id="element-140">
            DESCARGAR AHORA
          </Button>

          <div className="flex justify-center items-center space-x-4 text-xs text-gray-500" data-id="element-141">
            <div className="flex items-center" data-id="element-142">
              <Lock className="w-3 h-3 mr-1" data-id="element-143" />
              SSL Seguro
            </div>
            <div className="flex items-center" data-id="element-144">
              <CreditCard className="w-3 h-3 mr-1" data-id="element-145" />
              Privacidad Garantizada
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}